import { useCallback, useMemo } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, ButtonGroup, IconButton, Skeleton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SearchableMenu, SearchableMenuMultiSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { useSearchContext } from '../SearchProvider';
import { ActionContainer, FilterContainer } from './styled';
export function SearchFiltersToolbar(props) {
    const { filterItems, filterGroups, actions, filters, exclude, loading = false } = props;
    const { activeFilters, hasFilters, clearFilters, toggleFilter } = useSearchContext();
    const filtersToRender = useMemo(() => filterItems.filter((item) => activeFilters.includes(item.id)), [filterItems, activeFilters]);
    const stableFilterItems = useMemo(() => filterItems.filter((item) => !item.exclude && !(exclude === null || exclude === void 0 ? void 0 : exclude.includes(item.id))), [filterItems, exclude]);
    const handleSelect = useCallback((node) => toggleFilter(node.id), [toggleFilter]);
    return (<Box flexDirection="column" gap="lg">
      <ActionContainer>
        <Skeleton loading={loading}>
          <ButtonGroup>
            <SearchableMenu items={stableFilterItems} keys={['name']} groups={filterGroups} itemGroupKey="categoryId" renderTarget={<Button type="button" size="small" appearance="secondary">
                  <Falcon icon="plus"/>
                  <Trans comment="Search: Add filter menu button">Filters</Trans>
                </Button>}>
              <SearchableMenuMultiSelectList selected={activeFilters} onSelect={handleSelect} renderItem={(item) => item.name} flat={false}/>
            </SearchableMenu>

            {hasFilters && (<IconButton appearance="secondary" size="small" onClick={clearFilters} aria-label={t({ message: 'Remove all filters', comment: 'Filters: Clear all filters' })}>
                <Falcon icon="remove"/>
              </IconButton>)}
          </ButtonGroup>
        </Skeleton>

        {actions}
      </ActionContainer>

      <FilterContainer>
        {filters}

        {filtersToRender.map(({ id, component: Component }) => (<Component key={id}/>))}
      </FilterContainer>
    </Box>);
}
